import { useContext } from 'react';
import { GroupedPromoModelContext } from '../contexts/GroupedPromoModelProvider';

/**
 * Custom hook to access the GroupedPromoModel context.
 * @returns {Object} The context value from GroupedPromoModelContext.
 * - `isDisabled`: Boolean indicating if the grouped promo model is disabled.
 * - `items`: Dictionary format: { promotionId: [{itemId, quantity}, ...] }
 * - `groupedItemsByAnchor`: Dictionary of grouped items keyed by anchor itemId.
 * - `loading`: Boolean indicating if the data is still loading.
 * - `error`: Error message if any error occurred while fetching data.
 * - `bypassCartLogic`: Boolean flag to indicate cart logic should be bypassed.
 * - `currentActiveGroup`: Currently active/expanded promotion group.
 * - `setCurrentActiveGroup`: Function to set the current active group.
 * - `isGroupedContext`: Boolean flag indicating this is a grouped context.
 */
export const useGroupedPromoModel = () => useContext(GroupedPromoModelContext);
